import { request } from './request'

export const listSupplierBillVatBySupplierNamePopUp = (params) =>
  request({
    url: `/api/stock_vat/supplier_bill_vat/supplier_name/list`,
    method: 'get',
    params: params ?? null,
  })